import React, { useState } from "react";

import Checkbox from "@mui/material/Checkbox";

import Box from "@mui/material/Box";
import { IconButton, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CircleIcon from "@mui/icons-material/Circle";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import ContrastIcon from "@mui/icons-material/Contrast";

import Collapse from "@mui/material/Collapse";
import TransparencySlider from "./TransparencySlider";

import LayerInfo from "./LayerInfo";

export default function SingleCheckbox({
  checked,
  setChecked,
  shortDescription,
  longDescription,
  offset,
  setOffset,
}) {
  const [collapseOpen, setCollapseOpen] = useState(false);

  const key = Object.keys(checked);

  if (!checked || key.length !== 1) {
    return null;
  }
  const keyName = key[0];

  const handleChange = (event) => {
    setChecked((currentCheckedState) => {
      currentCheckedState[keyName].visible = event.target.checked;

      return { ...currentCheckedState };
    });
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "flex-start",
        }}
      >
        <Checkbox
          sx={{
            p: 1,
            color: checked[keyName].color,
            "&.Mui-checked": {
              color: checked[keyName].color,
            },
          }}
          icon={<CircleOutlinedIcon />}
          checkedIcon={<CircleIcon />}
          indeterminateIcon={<ContrastIcon />}
          checked={checked[key[0]].visible}
          onChange={handleChange}
        />
        <Typography
          sx={{ cursor: "pointer" }}
          onClick={() => setCollapseOpen(!collapseOpen)}
        >
          {key[0]}
        </Typography>
        <LayerInfo
          shortDescription={shortDescription}
          longDescription={longDescription}
          longDescriptionTitle={keyName}
        />
        {typeof offset === "number" && (
          <IconButton onClick={() => setCollapseOpen(!collapseOpen)}>
            {collapseOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        )}
      </Box>
      {typeof offset === "number" && (
        <Collapse in={collapseOpen}>
          <TransparencySlider offset={offset} setOffset={setOffset} />
        </Collapse>
      )}
    </>
  );
}
